//使い方
import endPoint from "../../plugins/scrollAddClass.js";
endPoint.init();

endPoint.init({
  target: '.c-contact-button.-fixed-sp',
  addClassName: "is-ended",
  triggerHook: "onEnter",
  offset: 90,
  leave: true
});


